/* import __COLOCATED_TEMPLATE__ from './input-panel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();